import PropTypes from "prop-types";
import SoftTypography from "components/SoftTypography";
import SoftBox from "components/SoftBox";
import SoftInput from "components/SoftInput";
import { Chip, Grid, MenuItem, OutlinedInput, Select, Stack } from "@mui/material";
import { useRef, useState } from "react";
import StyledTextarea from "components/StyledTextarea";

function JobCategoryAddEdit({ currentCategoryData, allCategories }) {
    const editorRef = useRef(null);
    const [defaultParentId, setDefaultParentId] = useState(currentCategoryData.parent_id);
    const [allKeywords, setAllKeywords] = useState(currentCategoryData.seo_keywords);
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    return <>
        <SoftBox component="form" role="form" style={{
            "margin": "0 16px"
        }}>
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                <Grid item xs={6}>
                    <SoftBox mb={2}>
                        <SoftBox mb={1} ml={0.5}>
                            <SoftTypography component="label" variant="caption" fontWeight="bold">
                                Category Name
                            </SoftTypography>
                        </SoftBox>
                        <SoftInput
                            type="text"
                            placeholder="Category Name"
                            defaultValue={currentCategoryData.name}
                            onChange={(event) => currentCategoryData.name = event.target.value} />
                    </SoftBox>
                </Grid>
                <Grid item xs={6}>
                    <SoftBox mb={2}>
                        <SoftBox mb={1} ml={0.5}>
                            <SoftTypography component="label" variant="caption" fontWeight="bold">
                                Parent Category
                            </SoftTypography>
                        </SoftBox>
                        <Select
                            displayEmpty
                            value={defaultParentId}
                            onChange={(event) => {
                                currentCategoryData.parent_id = event.target.value;
                                setDefaultParentId(currentCategoryData.parent_id);
                            }}
                            input={<OutlinedInput />}
                            MenuProps={MenuProps}
                        >
                            <MenuItem value="0">
                                Select Parent Category
                            </MenuItem>
                            {allCategories.map((singleCategory) => (
                                singleCategory.id !== currentCategoryData.id && singleCategory.parent_id !== currentCategoryData.id && <MenuItem
                                    key={singleCategory.id}
                                    value={singleCategory.id}
                                >
                                    {singleCategory.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </SoftBox>
                </Grid>
            </Grid>
        </SoftBox>
    </>;
}
JobCategoryAddEdit.defaultProps = {
    currentCategoryData: {},
    allCategories: [],
};
JobCategoryAddEdit.propTypes = {
    currentCategoryData: PropTypes.any.isRequired,
    allCategories: PropTypes.array.isRequired,
};

export default JobCategoryAddEdit;